import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getCoins } from "../services/coin_service.tsx";
import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "../services/authContext_service.tsx"; // ✅ DODATO

// slike
const background = require("../assets/view/background.png");
const field = require("../assets/view/field.png");
const leftPillar = require("../assets/view/left pillar.png");
const rightPillar = require("../assets/view/right pillar.png");

// NAV
const homeBtn = require("../assets/home button.png");
const yourCoinsBtn = require("../assets/your coins.png");
const numStoriesBtn = require("../assets/num stories button.png");
const signOutBtn = require("../assets/sign out button.png"); // ✅ DODATO

interface Coin {
    id: number;
    name: string;
}

const ITEMS_PER_PAGE = 14;

const ViewCoins = () => {
    const [coins, setCoins] = useState<Coin[]>([]);
    const [error, setError] = useState<string>("");
    const navigate = useNavigate();
    const { logout } = useAuth(); // ✅ DODATO

    const [page, setPage] = useState(1)

    const [loading, setLoading] = useState(true);
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const images = [
            background,
            field,
            leftPillar,
            rightPillar,
            homeBtn,
            yourCoinsBtn,
            numStoriesBtn,
            signOutBtn // ✅ DODATO
        ];

        let loaded = 0;

        images.forEach((src) => {
            const img = new Image();
            img.src = src;

            const done = () => {
                loaded++;
                if (loaded === images.length) {
                    setImagesLoaded(true);
                }
            };

            img.onload = done;
            img.onerror = done;
        });
    }, []);

    useEffect(() => {
        setLoading(false);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("accessToken");
        if (!token) {
            setError("You are not authenticated!");
            return;
        }

        const fetchCoins = async () => {
            try {
                const data = await getCoins(token);
                setCoins(data);
            } catch {
                setError("Error while loading coins.");
            }
        };

        fetchCoins();
    }, []);

    const totalPages = Math.ceil(coins.length / ITEMS_PER_PAGE);

    const paginatedCoins = coins.slice(
        (page - 1) * ITEMS_PER_PAGE,
        page * ITEMS_PER_PAGE
    );

    if (loading || !imagesLoaded) {
        return (
            <Box
                sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "black",
                }}
            >
                <CircularProgress size={80} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                backgroundImage: `url(${background})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                overflowX: "hidden"
            }}
        >
            <Box
                sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                    gap: { xs: 1, sm: 2, md: 4 },
                    zIndex: 5,
                    flexWrap: "wrap"
                }}
            >
                <img
                    src={homeBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/home")}
                />

                <img
                    src={yourCoinsBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/view-coins")}
                />

                <img
                    src={numStoriesBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={() => navigate("/home")}
                />

                {/* ✅ LOGOUT DUGME */}
                <img
                    src={signOutBtn}
                    style={{ width: "clamp(80px, 15vw, 140px)", cursor: "pointer" }}
                    onClick={logout}
                />
            </Box>

            {/* Ostatak koda NIJE MENJAN */}
            <Box
                component="img"
                src={leftPillar}
                sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    height: "90%",
                    display: { xs: "none", md: "block" },
                    opacity: 0.7
                }}
            />

            <Box
                component="img"
                src={rightPillar}
                sx={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    height: "90%",
                    display: { xs: "none", md: "block" },
                    opacity: 0.7
                }}
            />

            <Box
                sx={{
                    mt: 5,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    zIndex: 2,
                    width: "100%",
                    px: 2
                }}
            >
                {coins.length === 0 ? (
                    <Box
                        sx={{
                            textAlign: "center",
                            background: "rgba(0,0,0,0.4)",
                            padding: "30px",
                            borderRadius: "12px",
                            width: "100%",
                            maxWidth: "400px"
                        }}
                    >
                        <Typography sx={{ color: "white", fontSize: "clamp(20px, 5vw, 28px)", mb: 2 }}>
                            You don't have any coins yet
                        </Typography>

                        <Link
                            to="/home"
                            style={{
                                color: "#ff66ff",
                                fontSize: "18px",
                                textDecoration: "underline"
                            }}
                        >
                            Add coin
                        </Link>
                    </Box>
                ) : (
                    <>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    sm: "1fr",
                                    md: "repeat(2, 1fr)"
                                },
                                gap: "20px",
                                width: "100%",
                                maxWidth: "700px"
                            }}
                        >
                            {paginatedCoins.map((coin) => (
                                <Box
                                    key={coin.id}
                                    sx={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "300px",
                                        margin: "0 auto",
                                        cursor: "pointer",
                                        transition: "transform 0.2s",
                                        "&:hover": {
                                            transform: "scale(1.05)"
                                        }
                                    }}
                                    onClick={() => navigate(`/analyze/${coin.id}`)}
                                >
                                    <Box component="img" src={field} sx={{ width: "100%" }} />

                                    <Typography
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            color: "white",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            pointerEvents: "none",
                                            fontSize: "clamp(12px, 3vw, 16px)",
                                            textShadow: "0 0 8px rgba(0,0,0,0.8)"
                                        }}
                                    >
                                        {coin.name}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        {totalPages > 1 && (
                            <Box sx={{ mt: 3, display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
                                
                                <Typography
                                    onClick={() => setPage((p) => Math.max(p - 1, 1))}
                                    sx={{
                                        cursor: page === 1 ? "default" : "pointer",
                                        color: page === 1 ? "#666" : "#fff",
                                        px: 1
                                    }}
                                >
                                    ⬅
                                </Typography>

                                {[...Array(totalPages)].map((_, index) => {
                                    const pageNumber = index + 1;
                                    return (
                                        <Typography
                                            key={pageNumber}
                                            onClick={() => setPage(pageNumber)}
                                            sx={{
                                                cursor: "pointer",
                                                color: page === pageNumber ? "#ff00cc" : "#fff",
                                                fontWeight: page === pageNumber ? "bold" : "normal",
                                                px: 1,
                                                "&:hover": {
                                                    color: "#ff00cc"
                                                }
                                            }}
                                        >
                                            {pageNumber}
                                        </Typography>
                                    );
                                })}

                                <Typography
                                    onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                                    sx={{
                                        cursor: page === totalPages ? "default" : "pointer",
                                        color: page === totalPages ? "#666" : "#fff",
                                        px: 1
                                    }}
                                >
                                    ➡
                                </Typography>

                            </Box>
                        )}
                    </>
                )}
            </Box>

            {error && (
                <Box
                    sx={{
                        mt: "auto",
                        mb: 3,
                        background: "rgba(0,0,0,0.7)",
                        padding: "10px 20px",
                        borderRadius: "10px"
                    }}
                >
                    <Typography sx={{ color: "#ff4d6d" }}>
                        {error}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default ViewCoins;